import { render, staticRenderFns } from "./TFAOHOBB.vue?vue&type=template&id=162cf2f2&scoped=true&"
import script from "./TFAOHOBB.vue?vue&type=script&lang=js&"
export * from "./TFAOHOBB.vue?vue&type=script&lang=js&"
import style0 from "./TFAOHOBB.vue?vue&type=style&index=0&id=162cf2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162cf2f2",
  null
  
)

export default component.exports